import * as actionTypes from "Redux/Actions/actionTypes";
import { GET_VAULT, UPDATE_VAULT } from "../../../Redux/Actions/actionTypes";

const initialState = {
  success: null,
  error: null,
  idTypes: [],
  provinceList: [],
  formData: null,
  kycVault: null,
};

const AboutYouReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: action.response,
      };
    case actionTypes.GET_ID_TYPE_SUCCESS:
      return {
        ...state,
        idTypes: action.response.data,
        error: null,
      };
    case actionTypes.GET_ID_TYPE_ERROR:
      return {
        ...state,
        idTypes: [],
        error: action.error,
      };
    case actionTypes.GET_PROVINCE_LIST_SUCCESS:
      return {
        ...state,
        provinceList: action.response.data,
        error: null,
      };
    case actionTypes.GET_PROVINCE_LIST_ERROR:
      return {
        ...state,
        provinceList: [],
        error: action.error,
      };
    case actionTypes.SAVE_CREATE_APP_STATUS:
      return {
        ...state,
        formData: action.formData,
      };
    case `${GET_VAULT}_SUCCESS`:
      return {
        ...state,
        kycVault: action.data,
      };
    case `${UPDATE_VAULT}_SUCCESS`:
      return {
        ...state,
        kycVault: action.data,
      };
    default:
      return state;
  }
};

export default AboutYouReducer;
